import React from "react";
import { Flex } from "@bdo/cornerstone-ui";
import { RiErrorWarningLine } from "@remixicon/react";

interface Props {
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    console.error(
      "ErrorBoundary caught an error during getDerivedStateFromError",
      error
    );
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Flex
          fillViewport
          direction="column"
          justify="center"
          align="center"
          gap="xs"
        >
          <RiErrorWarningLine className="text-[64px] text-primary-darker" />
          <h1 className="text-lg text-mono-dark font-bold">
            Something went wrong!
          </h1>
          <span className="text-mono-dark">
            Return to the{" "}
            <a
              href="/"
              className="text-link hover:text-link-dark hover:underline"
            >
              workflows
            </a>
          </span>
        </Flex>
      );
    }

    return this.props.children;
  }
}
